module.exports = __webpack_public_path__ + "fonts/Golos-Text_Regular.217ac76.woff";